import { mixed, number, object } from 'yup';

import { getMinMaxDigitalValue } from '@constants/validationConstants';
import {
	ECommissionDate,
	ECommissionType,
	TCommissionDate,
	TCommissionType,
} from '@components/OrganisationProfile/AssetOwnerSettings/constants';

const MIN_VALUE = 0;
const MAX_PERCENT_VALUE = 100;
const MAX_FIXED_VALUE = 9_999_999;

export const schema = object({
	commissionType: mixed().oneOf(Object.values(ECommissionType)).required(),
	date: mixed().when('dateType', {
		is: (dateType: TCommissionDate) => dateType === ECommissionDate.startFromDate,
		then: number()
			.nullable()
			.transform((value) => (value || undefined))
			.required('Date is mandatory'),
		otherwise: number()
			.nullable()
			.transform((value) => (isNaN(value) ? undefined : value))
			.notRequired(),
	}),
	percentValue: mixed().when('commissionType', {
		is: (commissionType: TCommissionType) => commissionType === ECommissionType.percent,
		then: number()
			.nullable()
			.transform((value) => (isNaN(value) ? undefined : value))
			.min(MIN_VALUE, getMinMaxDigitalValue({ min: MIN_VALUE, max: MAX_PERCENT_VALUE }))
			.max(MAX_PERCENT_VALUE, getMinMaxDigitalValue({ min: MIN_VALUE, max: MAX_PERCENT_VALUE }))
			.required('% is mandatory'),
		otherwise: number()
			.nullable()
			.transform((value) => (isNaN(value) ? undefined : value))
			.notRequired(),
	}),
	fixedValue: mixed().when('commissionType', {
		is: (commissionType: TCommissionType) => commissionType === ECommissionType.fixed,
		then: number()
			.nullable()
			.transform((value) => (isNaN(value) ? undefined : value))
			.min(MIN_VALUE, getMinMaxDigitalValue({ min: MIN_VALUE, max: MAX_FIXED_VALUE }))
			.max(MAX_FIXED_VALUE, getMinMaxDigitalValue({ min: MIN_VALUE, max: MAX_FIXED_VALUE }))
			.required('Value is mandatory'),
		otherwise: number()
			.nullable()
			.transform((value) => (isNaN(value) ? undefined : value))
			.notRequired(),
	}),
});
